import CowsApi from "../../../api/cows-api";
import TagsApi from "../../../api/tags-api";
import SensorLogsApi from "../../../api/sensor-log-api";

// initial state
const initialState = () => ({
  isFetching: false,
  cows: [],
  cowsCleaned: [],
  cow: {},
  tags: [],
  tagList: [],
  //Used for neighbours function (stepping between cows)
  cowList: [],
  highTempInfo: [],
});

// actions
const actions = {
  getCows: async ({ commit }, payload) => {
    try {
      commit("request", payload);
      const apiResponse = await CowsApi.list(payload);

      if (apiResponse && apiResponse.data) {

        // sort the result by eartag
        const sorted = apiResponse.data.sort((a, b) => (b && b.eartag && a && a.eartag) ? a.eartag - b.eartag : 0);

        commit("getCowsSuccess", sorted);
      } else {
        commit("getCowsFailed", apiResponse);
      }
    } catch (e) {
      commit("getCowsFailed", e);
    }
  },

  getHighTempInfo: async ({ commit }) => {
    try {
      const response = await SensorLogsApi.getHighTempInfo();

      if (response && response.data){
        commit('getHighTempInfoSuccess', response.data);
      }else{
        commit('getHighTempInfoFailed', response);
      }
    } catch (e) {
      commit("getHighTempInfoFailed", e);
    }
  },

  clearCows: ({ commit }) => {
    commit("clearCows", initialState());
  },

  getCow: async ({ commit }, payload) => {
    const { cow_id } = payload || {};
    try {
      commit("request", payload);

      const apiResponse = await CowsApi.get(cow_id, payload);

      if (apiResponse && apiResponse.data) {
        commit("getCowSuccess", apiResponse.data);
      } else {
        commit("getCowFailed", apiResponse);
      }
    } catch (e) {
      commit("getCowFailed", e);
    }
  },

  clearCow: ({ commit }) => {
    commit("clearCow", initialState());
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  },

  getTags: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await TagsApi.getAll();
      if (apiResponse && apiResponse.data)
        commit("getTagSuccess", apiResponse.data);
      else
        commit("getTagFailed", apiResponse);
    } catch (e) {
      commit("getTagFailed", e);
    }
  },

  assignTags: async ({ commit }, payload) => {
    const { cow_ids, names } = payload || {}
    try {
      commit("request");
      const apiResponse = await TagsApi.assign({ cow_ids, names })
      if (!apiResponse || !apiResponse.data)
        commit("getTagFailed", apiResponse);
    } catch (e) {
      commit("assignTagFailed", e);
    }
  },

  clearTags: async ({ commit }, payload) => {
    const { cow_ids } = payload || {}
    try {
      commit("request");
      const apiResponse = await TagsApi.clear({ cow_ids })
      if (!apiResponse || !apiResponse.data)
        commit("getTagFailed", apiResponse);
    } catch (e) {
      commit("assignTagFailed", e);
    }
  },

  getTagsWithCow: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await TagsApi.getWithCow();
      if (apiResponse && apiResponse.data)
        commit("getTagWithCowSuccess", apiResponse.data);
      else
        commit("getTagWithCowFailed", apiResponse);
    } catch (e) {
      commit("getTagWithCowFailed", e);
    }
  },

  setCowList({ commit }, payload) {
    commit("setCowList", payload);
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  getCowsSuccess: (state, payload) => {
    state.isFetching = false;
    state.cows = payload;
  },
  getCowsFailed: state => {
    state.isFetching = false;
  },
  clearCows: (state, initialState) => {
    state.cows = initialState.cows;
  },
  getCowSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.cow = payload;
  },
  getHighTempInfoSuccess: (state, payload = []) => {
    state.highTempInfo = payload;
  },
  getHighTempInfoFailed: state => {
    state.highTempInfo = [];
  },
  getCowFailed: state => {
    state.isFetching = false;
  },
  clearCow: (state, initialState) => {
    state.cow = initialState.cow;
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  },
  getTagSuccess: (state, payload = {}) => {
    state.tagList = payload;
  },
  getTagFailed: () => { },
  getTagWithCowSuccess: (state, payload = {}) => {
    state.tags = payload;
  },
  getTagWithCowFailed: () => { },
  setCowList: (state, payload) => {
    state.cowList = (payload && payload.filter(x => x && !x.archived_at && !x.deleted_at)) || [];
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/cows.js